import { render } from "./ModuleMenuV2.vue?vue&type=template&id=bb789d1e&scoped=true"
import script from "./ModuleMenuV2.vue?vue&type=script&lang=js"
export * from "./ModuleMenuV2.vue?vue&type=script&lang=js"

import "./ModuleMenuV2.vue?vue&type=style&index=0&id=bb789d1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb789d1e"]])

export default __exports__